import Token from './token'
import Form from './form'

export default {
  svg: 'message_square',
  label: 'Send SMS',
  type: 'communication',
  action: 'sms',
  form: Form,
  token: Token
}
